import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/DIAPER';

export const {action: show} = createAction(`${domain}/SHOW`, (institutionId, childIds, canAddDiaperToiletAccident) => ({
    institutionId,
    childIds,
    canAddDiaperToiletAccident,
}));

export const {action: hide} = createAction(`${domain}/HIDE`);

export const {action: toggleTimeForm} = createAction(`${domain}/SHOW_TIME_FORM`);

export const {action: toggleNoteForm} = createAction(`${domain}/SHOW_NOTE_FORM`);

export const {
    action: diaper,
    success: diaperSuccess,
    failed: diaperFailure,
} = createAction(`${domain}/DIAPER`, (childIds, actionType, diaperingType, note, time) => ({
    childIds,
    actionType,
    diaperingType,
    note,
    time,
}));
